import React from 'react'
import { Field, reduxForm } from 'redux-form'
import {renderTextField} from './../../utils/materialUiReduxForms';
import { literals } from './../../languages';

const LoginForm = props => {
  const { handleSubmit, pristine, submitting } = props;
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Field floatingLabelFocusStyle={{color:'#007bff'}} underlineFocusStyle={{borderColor:'#007bff'}} type="text" name="email" component={renderTextField} label={literals.email[props.locale]} />
      </div>
      <div>
        <Field floatingLabelFocusStyle={{color:'#007bff'}} underlineFocusStyle={{borderColor:'#007bff'}}  type="password" name="password" component={renderTextField} label={literals.password[props.locale]} />
      </div>
      <div className="action-btns">
        <button className="btn btn-primary" type="submit" disabled={pristine || submitting}>{literals.submit[props.locale]}</button>
        {/* <button className="btn btn-secondary" type="button" disabled={pristine || submitting} onClick={reset}>
          Clear Values
        </button> */}
        <div onClick={()=>{props.browserHistory.push('/register')}} className="btn btn-secondary">{literals.register[props.locale]}</div>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'LoginForm', // a unique identifier for this form
  // validate,
  // asyncValidate,
})(LoginForm)


// WEBPACK FOOTER //
// ./src/components/login/index.js